import { User } from '../model/User';
import Constants from '../constants/constants';

export const formatDate = (date: string | number): string => {
  const parseDate =
    typeof date === 'string' ? new Date(date) : new Date(date * 1000);
  return parseDate.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const formatDateTime = (date: string | number): string => {
  const parseDate =
    typeof date === 'string' ? new Date(date) : new Date(date * 1000);
  return parseDate.toLocaleTimeString('ru-RU', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
};

export const formatHtmlString = (htmlString: string): string => {
  const maxLength = 165;
  const formatString = htmlString.replace(/<[^>]+>/g, '');
  return (
    formatString.substring(0, maxLength) +
    (formatString.length > maxLength ? '...' : '')
  );
};

export const shortUserName = (user: User): string => {
  return (
    user.lastName +
    ' ' +
    user.firstName.charAt(0) +
    '. ' +
    user.middleName.charAt(0) +
    '.'
  );
};

export const formatFileSize = (size: number): string => {
  size = Math.floor(size / 1000000);
  return size + 'Мб';
};

export const getAnswerStatusText = (
  holdTo: string | null,
  status: boolean | null
): string => {
  if (holdTo && status) {
    return 'Ответ отложен';
  } else {
    switch (status) {
      case true:
        return 'Ответ отправлен';
      case false:
        return 'Согласование отклонено';
      default:
        return 'На согласовании';
    }
  }
};

export const getResolveStatusText = (status: boolean | null): string => {
  switch (status) {
    case true:
      return 'Согласовано';
    case false:
      return 'Согласование отклонено';
    default:
      return 'На согласовании';
  }
};

export const absAttachmentUrl = (url: string): string => {
  return Constants.ServerProtocol + '://' + Constants.ServerDomain + url;
};

export const convertErrorCode = (
  code: string,
  message: string,
  accepts: string[],
  maxSize: number,
  maxFiles: number
): string => {
  if (code == 'file-invalid-type') {
    message =
      'Некорретный тип файла. Допустимые форматы jpeg, jpg, png, pdf, x-pdf' +
      (accepts.join(', ') ? ', gif, doc, docx' : '');
  }
  if (code == 'file-too-large') {
    message =
      'Слишком большой файл. Максимальный размер файла ' +
      formatFileSize(maxSize);
  }
  if (code == 'too-many-files') {
    message = 'Слишком много файлов. Максимум ' + maxFiles + ' файлов';
  }
  return message;
};
